import Menu from './pages/components/Menu'
import TopInfo from './pages/components/TopInfo'

const Base = ({ openMenu, setOpenMenu, toggle, theme }) => {
  return (
    <>
      <Menu openMenu={openMenu} setOpenMenu={setOpenMenu} />

      <TopInfo toggle={toggle} theme={theme} />
    </>
  )
}

export default Base
